import React from 'react';
import { useSelector } from 'react-redux';
import { selectedCultureSelector } from '../../store/component-state/component-state.selectors';
export default function FormatNumber(props) {
    const culture = useSelector(selectedCultureSelector);
    return props.toFormat
        ? React.createElement("span", null, props.toFormat.toLocaleString(culture, { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
        : null;
}
